export default "__VITE_ASSET__D$ZKXNeY__"